import { render, staticRenderFns } from "./Prepayments.vue?vue&type=template&id=2f3e377c&scoped=true"
import script from "./Prepayments.vue?vue&type=script&lang=js"
export * from "./Prepayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3e377c",
  null
  
)

export default component.exports